/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface ISetLocationModalScope extends ng.IScope {
        initLong: number;
        initLat: number;

        modalClose: () => void;
        modalSave: () => void;

        initMap: () => void;
        window: google.maps.custom.IWindow;
        searchModel: google.maps.custom.ISearchModel;
        map: google.maps.custom.IMapObject;
        searchbox: google.maps.custom.ISearchBox;
        defaultBounds: google.maps.LatLngBounds;
        showPlaceDetails: (place: google.maps.custom.IAddress) => void;
    }

    /**
     * SetLocationModalController class
     */
    export class SetLocationModalController {
        public static templateURL: string = "decorators/modals/set-location-modal.html";
        public static ID: string = "#id-set-location-modal";
        public static $name: string = "setLocationModalController";
        public static $inject: string[] = ['$scope',
                                           'close',
                                           'initLat',
                                           'initLong',
                                           'uiGmapGoogleMapApi',
                                           '$timeout',
                                           '$templateCache',
                                           'geocodeService',
                                           ];

        private $scope: ISetLocationModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;
        private uiGmapGoogleMapApi: ng.IPromise<Object>;
        private $timeout: ng.ITimeoutService;
        private $templateCache: ng.ITemplateCacheService;
        private geocodeService: Services.GeocodeService;

        /**
         * Constructor
         */
        constructor($scope: ISetLocationModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    initLat: number,
                    initLong: number,
                    uiGmapGoogleMapApi: ng.IPromise<Object>,
                    $timeout: ng.ITimeoutService,
                    $templateCache: ng.ITemplateCacheService,
                    geocodeService: Services.GeocodeService) {
            this.$scope = $scope;
            this.close = close;
            this.$scope.initLong = initLong;
            this.$scope.initLat = initLat;
            this.uiGmapGoogleMapApi = uiGmapGoogleMapApi;
            this.$timeout = $timeout;
            this.$templateCache = $templateCache;
            this.geocodeService = geocodeService;

            let self: SetLocationModalController = this;

            this.$scope.searchModel = {
                searchTerm: '',
            };

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                let myObj: Object = {
                    lat: this.$scope.window.coords.latitude,
                    lng: this.$scope.window.coords.longitude,
                    address: this.$scope.window.templateparameter.formatted_address,
                };
                this.close(myObj);
            };

            this.$scope.initMap = (): void => {
                this.$templateCache.put('searchbox.tpl.html',
                    '<input id="pac-input" class="pac-controls" type="text" ng-model="ngModel" placeHolder="Search">');
                this.$templateCache.put('window.tpl.html',
                    '<div ng-cloak style="z-index: 15000" ng-bind-html="parameter.formatted_address"></div>');

                this.$scope.window = {
                    show: false,
                    options: {
                        pixelOffset: {
                            width: 0,
                            height: -40,
                        },
                    },
                    templateurl: 'window.tpl.html',
                    templateparameter: {},
                    closeClick: (): void => {
                        this.$scope.window.show = false;
                    },
                    coords: {},
                };

                this.$scope.map = {
                    control: {},
                    center: {
                        latitude: initLat,
                        longitude: initLong,
                    },
                    zoom: 10,
                    dragging: true,
                    bounds: {},
                    markers: [],
                    idkey: 'place_id',
                    events: {
                        idle: function (map: google.maps.Map): void {
                            //
                        },
                        dragend: function(map: google.maps.Map): void {
                            // update the search box bounds after dragging the map
                            let bounds: google.maps.LatLngBounds = map.getBounds();
                            if (bounds !== undefined) {
                                let ne: google.maps.LatLng = bounds.getNorthEast();
                                let sw: google.maps.LatLng = bounds.getSouthWest(); 
                                self.$scope.searchbox.options.bounds = new google.maps.LatLngBounds(sw, ne);
                            }
                        },
                        click: (map: google.maps.Map, event: string, attr: google.maps.MouseEvent): void => {
                            let newMarkers: google.maps.custom.IMarker[] = [];
                            this.geocodeService
                                .address(attr[0].latLng.lat(), attr[0].latLng.lng())
                                .then((response: google.maps.custom.IGeocodingResponse) => {
                                    let marker: google.maps.custom.IMarker = {
                                        idKey: 0,
                                        place_id: response.results[0].place_id,
                                        name: '',
                                        latitude: attr[0].latLng.lat(),
                                        longitude: attr[0].latLng.lng(),
                                        templateurl: 'window.tpl.html',
                                        templateparameter: undefined,
                                        events: {
                                            click: (m: google.maps.Map, e: string, mrkr: google.maps.custom.IMarker): void => {
                                                this.geocodeService
                                                    .address(marker.latitude, marker.longitude)
                                                    .then((res: google.maps.custom.IGeocodingResponse) => {
                                                        this.$scope.window.templateparameter = res.results[0];
                                                        this.$scope.searchModel.searchTerm = res.results[0].formatted_address;
                                                        this.$scope.window.show = true;
                                                    });
                                                this.$scope.window.coords = {
                                                    latitude: marker.latitude,
                                                    longitude: marker.longitude,
                                                };
                                            },
                                            dragstart: (m: google.maps.Map, e: string, mrkr: google.maps.custom.IMarker): void => {
                                                this.$scope.window.show = false;
                                                this.$scope.searchModel.searchTerm = '';
                                            },
                                            dragend: (m: google.maps.Map, e: string, mrkr: google.maps.custom.IMarker): void => {
                                                this.geocodeService
                                                    .address(mrkr.latitude, marker.longitude)
                                                    .then((res: google.maps.custom.IGeocodingResponse) => {
                                                        this.$scope.window.templateparameter = res.results[0];
                                                        this.$scope.searchModel.searchTerm = res.results[0].formatted_address;
                                                        this.$scope.window.show = true;
                                                    });
                                                this.$scope.window.coords = {
                                                    latitude: marker.latitude,
                                                    longitude: marker.longitude,
                                                };
                                            },
                                        },
                                    };
                                    newMarkers.push(marker);
                                    this.$scope.window.coords = {
                                        latitude: attr[0].latLng.lat(),
                                        longitude:  attr[0].latLng.lng(),
                                    };
                                    this.$scope.window.templateparameter = response.results[0];
                                    this.$scope.window.show = true;
                                    this.$scope.map.markers = newMarkers;
                                });
                        },
                    },
                    options: {
                        streetViewControl: false,
                        maxZoom: 22,
                        minZoom: 3,
                    },
                    markerOptions: {
                        draggable: true,
                    },
                };

                this.$scope.searchbox = {
                    template: 'searchbox.tpl.html',
                    position: 'top-left',
                    options: {
                        bounds: {},
                    },
                    events: {
                        places_changed: (searchBox: google.maps.places.SearchBox): void => {
                            let places: google.maps.places.PlaceResult[] = searchBox.getPlaces();
                            if (places.length === 0)
                                return;
                            // for each place, get the icon, place name, and location.
                            let newMarkers: google.maps.custom.IMarker[] = [];
                            let bounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();
                            for (let i: number = 0; i < places.length; i++) {
                                if (places[i] !== undefined) {
                                    // create a marker for each place.
                                    let marker: google.maps.custom.IMarker = {
                                        idKey: i,
                                        place_id: places[i].place_id,
                                        name: places[i].name,
                                        latitude: places[i].geometry.location.lat(),
                                        longitude: places[i].geometry.location.lng(),
                                        templateurl: 'window.tpl.html',
                                        templateparameter: places[i],
                                        events: {
                                            click: (map: google.maps.Map, event: string, marker: google.maps.custom.IMarker): void => {
                                                this.geocodeService
                                                    .address(marker.latitude, marker.longitude)
                                                    .then((res: google.maps.custom.IGeocodingResponse) => {
                                                        this.$scope.window.templateparameter = res.results[0];
                                                        this.$scope.searchModel.searchTerm = res.results[0].formatted_address;
                                                        this.$scope.window.show = true;
                                                    });
                                                this.$scope.window.coords = {
                                                    latitude: marker.latitude,
                                                    longitude: marker.longitude,
                                                };
                                            },
                                            dragstart: (map: google.maps.Map, event: string, marker: google.maps.custom.IMarker): void => {
                                                this.$scope.window.show = false;
                                                this.$scope.searchModel.searchTerm = '';
                                            },
                                            dragend: (map: google.maps.Map, event: string, marker: google.maps.custom.IMarker): void => {
                                                this.geocodeService
                                                    .address(marker.latitude, marker.longitude)
                                                    .then((res: google.maps.custom.IGeocodingResponse) => {
                                                        this.$scope.window.templateparameter = res.results[0];
                                                        this.$scope.searchModel.searchTerm = res.results[0].formatted_address;
                                                        this.$scope.window.show = true;
                                                    });
                                                this.$scope.window.coords = {
                                                    latitude: marker.latitude,
                                                    longitude: marker.longitude,
                                                };
                                            },
                                        },
                                    };
                                    newMarkers.push(marker);
                                    bounds.extend(places[i].geometry.location);
                                    this.$scope.window.coords = {
                                        latitude: places[i].geometry.location.lat(),
                                        longitude:  places[i].geometry.location.lng(),
                                    };
                                    this.$scope.window.templateparameter = places[i];
                                    this.$scope.window.show = true;
                                }
                            }
                            this.$scope.map.bounds = {
                                northeast: {
                                    latitude: bounds.getNorthEast().lat(),
                                    longitude: bounds.getNorthEast().lng(),
                                },
                                southwest: {
                                    latitude: bounds.getSouthWest().lat(),
                                    longitude: bounds.getSouthWest().lng(),
                                },
                            };
                            this.$scope.map.markers = newMarkers;
                        },
                    },
                };



                this.$timeout(() => {
                    this.uiGmapGoogleMapApi.then((maps: google.maps.custom.IGMapApiPromiseObject) => {
                        maps.defaultBounds = true;
                        this.$scope.defaultBounds = new google.maps.LatLngBounds(
                            new google.maps.LatLng(40.4902688, -3.6932825),
                            new google.maps.LatLng(40.9902688, -3.1932825)
                        );
                        this.$scope.map.bounds = {
                            northeast: {
                                latitude: this.$scope.defaultBounds.getNorthEast().lat(),
                                longitude: this.$scope.defaultBounds.getNorthEast().lng(),
                            },
                            southwest: {
                                latitude: this.$scope.defaultBounds.getSouthWest().lat(),
                                longitude: this.$scope.defaultBounds.getSouthWest().lng(),
                            },
                        };
                        this.$scope.searchbox.options.bounds = new google.maps.LatLngBounds(
                            this.$scope.defaultBounds.getNorthEast(),
                            this.$scope.defaultBounds.getSouthWest()
                        );
                    });
                }, 500);

                this.$scope.$on('$destroy', () => {
                    this.$templateCache.destroy();
                });
            };
        }
    }
}
